import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
export function useMediaQuery(query) {
  const $ = _c(3);
  const [matches, setMatches] = useState(false);
  let t0;
  let t1;
  if ($[0] !== query) {
    t0 = () => {
      const m = globalThis.window?.matchMedia?.(query);
      if (!m) {
        return;
      }
      setMatches(m.matches);
      const handler = e => setMatches(e.matches);
      m.addEventListener("change", handler);
      return () => m.removeEventListener("change", handler);
    };
    t1 = [query];
    $[0] = query;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return matches;
}